module.exports = "https://store.zigzag.kr/resources/arm64/20260320-1124-2ba6be3813_store/_next/static/images/MedalGold-67d427e62f4a62d9e05fff319ca044f1.png";